import React from "react";
import PropTypes from "prop-types";

import Button from "../Components/Button";

class RegistrationCallToAction extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    render() {
        return (
            <React.Fragment>
                <Button
                    label={this.props.label}
                    icon={this.props.icon}
                    className="btn btn-lx"
                    onClick={this.openModal}
                />
            </React.Fragment>
        );
    }

    openModal() {
        document.getElementById("registrationModal").style.display = "block";
    }

    closeModal() {
        document.getElementById("registrationModal").style.display = "none";
    }
}

RegistrationCallToAction.defaultProps = {
    label: "Create an Account",
    icon: "fa fa-id-card"
};

RegistrationCallToAction.propTypes = {
    label: PropTypes.string,
    icon: PropTypes.string
};

export { RegistrationCallToAction };
